export enum RentalReservationStatusEnum {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
}

export const rentalReservationStatusColorMap: Record<RentalReservationStatusEnum, string> = {
  [RentalReservationStatusEnum.Pending]: '#FFD889',
  [RentalReservationStatusEnum.Approved]: '#C1FFEA',
  [RentalReservationStatusEnum.Rejected]: '#FFA39E',
  [RentalReservationStatusEnum.Cancelled]: '#DCDCDC',
};
